import React, { useState } from 'react';
import { Button, Flex, Input, Form, Typography } from 'antd';
import Lottie from 'lottie-react';
import { firebaseAuth } from 'services/firebase/firebase-auth';
import type { IEmailFormFields } from 'client-app/components/login/email-form/types';
import styles from './email-form.module.scss';
import truckSpinnerLottie from './truck-spinner.json';

export const EmailForm: React.FC = () => {
  const [isSent, setIsSent] = useState(false);
  const [form] = Form.useForm();

  const handleFinish = async (values: IEmailFormFields) => {
    await firebaseAuth.emailLinkSend(values.email);
    setIsSent(true);
  };

  const handleResend = () => {
    setIsSent(false);
    form.resetFields();
  };

  if (isSent) {
    return (
      <Flex gap='middle' vertical>
        <div>
          <Typography.Text type='secondary'>We sent you a link for authorization</Typography.Text>
          <br />
          <Typography.Text type='secondary'>
            Check your email for a sign in (<b>{form.getFieldValue('email')}</b>)
          </Typography.Text>
        </div>
        <Lottie loop={false} animationData={truckSpinnerLottie} className={styles.animation} />
        <Button type='link' className={styles.resendButton} onClick={handleResend}>
          Resend Email
        </Button>
      </Flex>
    );
  }

  return (
    <Flex gap='middle' vertical>
      <Typography.Text type='secondary'>Please enter your email below to sign in</Typography.Text>
      <Form form={form} name='login' layout='vertical' validateTrigger='onSubmit' onFinish={handleFinish}>
        <Form.Item name='email' rules={[{ required: true, type: 'email' }]}>
          <Input size='large' placeholder='Email' autoFocus />
        </Form.Item>
        <Button htmlType='submit' size='large' type='primary' block>
          Continue
        </Button>
      </Form>
    </Flex>
  );
};
